<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md9 lg10 xl7>
        <v-card class="elevation-2 text-md-center">
          <progress-bar :show="isLoading" class="my-0 py-0"></progress-bar>
          <v-toolbar dark color="primary" flat>
            <!-- <v-toolbar-title v-if="!not_virtual">Acceso - Asamblea Virtual</v-toolbar-title> -->
            <v-toolbar-title
              >Acceso - {{ assemblyData.description }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn
              href="https://app.columbus.edu.co/app/storage/guides/como_votar_en_la_asamblea.mp4"
              target="blank"
              color="white"
              flat
              depressed
              round
            >
              <v-icon class="mr-2">help</v-icon> Tutorial
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="not_found && !isLoading">
            <h3>No hay asambleas activas</h3>
          </v-card-text>
          <v-card-text v-else-if="!not_virtual">
            <h3
              v-if="Object.keys(assemblyData).length > 0"
              class="headline font-weight-bold"
            >
              {{ assemblyData.description }}
            </h3>
            <v-layout v-if="Object.keys(assemblyData).length == 0 && isLoading">
              <v-alert
                :value="true"
                color="info"
                icon="hourglass_empty"
                outline
              >
                Cargando datos de la Asamblea...
              </v-alert>
            </v-layout>
            <v-layout
              v-else-if="!!assemblyData && !isLoading"
              class="grey lighten-4 mt-3 pa-3"
              row
              wrap
            >
              <v-flex
                v-if="assemblyData.assembly_date"
                :key="counter + 'assembly-data'"
                md12
                class="pa-1"
              >
                <b>Fecha asamblea:</b> {{ assemblyData.assembly_date }}
                {{ assemblyData.assembly_time.substring(0, 5) }}
                <span
                  v-if="assemblyData.assembly_time"
                  md12
                  class="pa-1"
                  :class="diffAssembly[0] == '+' ? 'red--text' : ''"
                  >({{
                    showCounter(
                      assemblyData.assembly_date +
                        " " +
                        assemblyData.assembly_time
                    )
                  }})</span
                >
                <span
                  v-if="assemblyData.assembly_finish_time"
                  class="font-weight-bold"
                  :class="leftTime >= 0 ? 'red--text' : ''"
                >
                  a {{ assemblyData.assembly_finish_time.substring(0, 5) }} ({{
                    showCounter(
                      assemblyData.assembly_date +
                        " " +
                        assemblyData.assembly_finish_time.substring(0, 5),
                      true
                    )
                  }})</span
                >
                <span
                  v-if="diffAssembly[1] != '0' && diffAssembly[0] == '+'"
                  class="red--text"
                  >La asamblea finalizó {{ formatTime(diffAssembly) }}</span
                >
                <span v-if="diffAssembly[0] == '-'" class="red--text"
                  >La asamblea aún no sucede</span
                >
              </v-flex>
              <v-flex
                v-if="assemblyData.first_call_time"
                :key="counter + 'conv1'"
                md12
                lg12
                xl12
                class="pa-1"
                :class="diffSecondCall[0] == '+' ? 'grey--text' : ''"
              >
                <b>1<sup>a</sup> convocatoria:</b>
                {{ assemblyData.first_call_time.substring(0, 5) }}
                <span
                  :class="
                    diffSecondCall[0] == '-' && diffFirstCall[0] == '+'
                      ? 'red--text'
                      : ''
                  "
                  >({{
                    showCounter(
                      assemblyData.assembly_date +
                        " " +
                        assemblyData.first_call_time
                    )
                  }})</span
                >
                - Quórum mínimo
                {{
                  new Intl.NumberFormat("en-US").format(
                    assemblyData.min_percentage_first_call
                  )
                }}%+1 ({{ total_atendance }} de
                {{
                  parseInt(
                    (total_active_families *
                      assemblyData.min_percentage_first_call) /
                      100,
                    0
                  ) + 1
                }})
              </v-flex>
              <v-flex
                v-if="assemblyData.second_call_time"
                :key="counter + 'conv2'"
                md12
                class="pa-1"
                :class="diffSecondCall[0] == '-' ? 'grey--text' : ''"
              >
                <b>2<sup>a</sup> convocatoria:</b>
                {{ assemblyData.second_call_time.substring(0, 5) }}
                <span :class="diffSecondCall[0] == '+' ? 'red--text' : ''"
                  >({{
                    showCounter(
                      assemblyData.assembly_date +
                        " " +
                        assemblyData.second_call_time
                    )
                  }})
                </span>
                - Quórum mínimo
                {{
                  new Intl.NumberFormat("en-US").format(
                    assemblyData.min_percentage_second_call
                  )
                }}% ({{ total_atendance }} de
                {{
                  parseInt(
                    (total_active_families *
                      assemblyData.min_percentage_second_call) /
                      100,
                    0
                  )
                }})
              </v-flex>
              <v-flex
                v-if="
                  diffAssembly[1] == '0' &&
                    assemblyData.virtual_meet_link &&
                    !disabledLink &&
                    Object.keys(powerGranted).length === 0
                "
                md12
                class="pa-1"
                ><b>Link de acceso:</b>
                <v-btn
                  v-if="!alreadyAssist"
                  color="primary"
                  :disabled="
                    !idAssembly ||
                      not_virtual ||
                      not_found ||
                      isLoading ||
                      alreadyAssist
                  "
                  @click="virtualAssistant"
                  >Unirse ahora para ver link</v-btn
                >
                <a
                  v-if="diffAssembly[1] == '0' && alreadyAssist"
                  :href="assemblyData.virtual_meet_link"
                  target="_blank"
                  >{{ assemblyData.virtual_meet_link }}</a
                >
                <v-alert
                  :value="true && alreadyAssist"
                  type="info"
                  dismissible
                  outline
                >
                  Por favor, ingrese al link indicado sin cerrar esta ventana.
                </v-alert>
              </v-flex>
            </v-layout>
            <v-layout
              v-if="familyId"
              class="grey lighten-4 mt-2 pa-3 text-md-left"
              row
              wrap
            >
              <h3 class="title blue--text text-darken-1 mb-2">
                Información importante
              </h3>
              <v-flex md12>
                <ul>
                  <li v-if="Object.keys(powerGranted).length > 0">
                    Poder
                    <span
                      v-html="statusDocument(powerGranted.document_status)"
                    ></span>
                    otorgado a: {{ powerGranted.family_name }} - Recepción:
                    <span
                      v-html="
                        statusDocument(
                          powerGranted.family_receives_power_status
                        )
                      "
                    ></span>
                  </li>
                  <li>
                    Estudiantes a su cargo: {{ activeStudent
                    }}<span
                      class="grey--text"
                      v-if="
                        Object.keys(powerTaken).length > 0 &&
                          powerTaken.at_charge_students > 0
                      "
                      ><b>+{{ powerTaken.at_charge_students }}</b></span
                    >
                  </li>
                  <li v-if="powerFilter(powersReceived, 'A').length > 0">
                    <b
                      >Poderes recibidos:
                      {{
                        powerFilter(powersReceived, "A").length > 0
                          ? powerFilter(powersReceived, "A").length
                          : 0
                      }}
                    </b>
                    <div
                      v-if="
                        Object.keys(powerTaken).length > 0 &&
                          powerTaken.incoming_powers > 0 &&
                          assemblyData.assembly_is_active === 0
                      "
                    >
                      <v-tooltip top max-width="300" color="info">
                        <template v-slot:activator="{ on }">
                          <span class="orange--text" v-on="on">
                            <b
                              >{{ powerTaken.incoming_powers | 0 }} poderes en
                              espera</b
                            >
                            <v-icon color="info" small>help</v-icon>
                          </span>
                        </template>
                        <span
                          >Dichos poderes no tendrán efecto como asistencia ni
                          como voto, hasta que no los acepte y firme el poder
                          recibido, en el módulo de Gestión de Poders (antes de
                          finalizar la asamblea).</span
                        >
                      </v-tooltip>
                    </div>
                  </li>
                  <li v-if="Object.keys(powerTaken).length > 0">
                    Poder firmado:
                    <span
                      v-html="statusDocument(powerTaken.document_status)"
                    ></span>
                  </li>
                  <li>
                    Tipo de acceso:
                    <span class="blue--text text--darken-1"
                      >{{
                        Object.keys(assemblyMember).length &&
                        assemblyMember.is_member
                          ? "Miembro de junta"
                          : Object.keys(assemblyMember).length &&
                            assemblyMember.is_employee
                          ? "Empleado"
                          : "Familia"
                      }}
                      <b v-if="asopaf == 1">ASOPAF</b>
                    </span>
                  </li>
                </ul>
              </v-flex>
            </v-layout>
            <v-layout v-if="assemblyError && !isLoading">
              <v-alert
                :value="true"
                color="warning"
                icon="priority_high"
                outline
              >
                {{ assemblyError }}
              </v-alert>
            </v-layout>
          </v-card-text>
          <div
            v-if="
              family && not_virtual && !alreadyAssist && parseInt(balance) <= 0
            "
          >
            <v-card-text>
              <v-layout>
                <v-flex>
                  <template v-if="validacionCompleta">
                    <span></span>
                    Código QR<br />
                    <vue-qrcode
                      :value="family.token"
                      :options="qr_options"
                      tag="img"
                    ></vue-qrcode>
                  </template>
                </v-flex>
              </v-layout>
            </v-card-text>
          </div>
          <div v-else>
            <v-card-text
              v-if="familyId && allValidations == '' && leftTime < 0"
            >
              <v-layout>
                <v-flex v-if="questions.length == 0 && !isLoading">
                  Espere un momento mientras el Administrador de la asamblea
                  activa los puntos a responder.
                </v-flex>
                <v-flex v-else-if="questions.length > 0" class="text-md-left">
                  Oprima "Actualizar" cuando el Administrador de la asamblea lo
                  indique. Por favor, no cierre esta ventana mientras no
                  finalice la asamblea:
                  <questionsComponent
                    v-on:getAssemblyPlease="getAssembly('refresh')"
                    :questions-object="questions"
                    :answers-object="answers"
                    :asopaf="asopaf"
                    :current-time="currentTime"
                  >
                  </questionsComponent>
                  <span class="right grey--text"
                    ><i
                      ><b>Última actualización:</b>
                      {{ currentTime.toLocaleTimeString() }}</i
                    ></span
                  >
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text v-else :key="counter + 'errors'">
              <v-alert
                v-if="!familyId && !not_found"
                :value="true"
                color="info"
                outline
                icon="hourglass_empty"
              >
                Cargando datos de su familia...
              </v-alert>
              <v-alert
                v-if="(familyId && allValidations != '') || leftTime >= 0"
                :value="true"
                outline
                class="body-2 pa-2"
              >
                <div v-html="allValidations"></div>
              </v-alert>
            </v-card-text>
            <v-tooltip top>
              <v-btn
                v-if="!isLoading"
                @click="getAssembly('refresh')"
                :loading="isLoading || loadingAssembly"
                dark
                color="blue"
                depressed
                slot="activator"
                ><v-icon class="mr-2">cached</v-icon> Actualizar</v-btn
              >
              <span>Actualizar datos de la asamblea para eventos en vivo</span>
            </v-tooltip>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import DigitalSignComponent from "~/pages/documents/digital_sign";
import QuestionsComponent from "~/pages/assembly/questions-component";
import { mapGetters } from "vuex";

export default {
  name: "assembly-assistance-view",
  components: {
    DigitalSignComponent,
    QuestionsComponent,
    VueQrcode
  },
  data: () => ({
    showQR: false,
    isLoading: false,
    currentTime: new Date(),
    interval: null,
    counter: 0,
    disabledLink: true,
    leftTime: -1,
    loadingAssembly: false,
    idAssembly: null,
    assemblyError: null,
    assemblyData: {},
    assemblyDocuments: {},
    total_active_families: 0,
    questions: [],
    answers: [],
    delegated_powers_limit: 0,
    quorum: 0,
    assemblyIsClosed: false,
    diffAssembly: [],
    diffFinishAssembly: [],
    diffFirstCall: [],
    diffSecondCall: [],
    not_found: false,
    not_virtual: false,

    familyId: null,
    family: null,
    powerGranted: {},
    powersReceived: [],
    balance: 0,
    asopaf: null,
    powerTaken: {},
    assemblyMember: {},
    activeStudent: 0,
    total_atendance: 0,
    alreadyAssist: false,
    break: false,
    qr_options: {
      maskPattern: 7,
      width: 250,
      color: {
        dark: "#000000",
        light: "#ffffff"
      },
      margin: 1
    },
    validacionCompleta: false
  }),
  created() {
    this.getAssembly(null, true);
    this.incrementCounter();
  },
  methods: {
    getAssembly(type = null, validate_assistance = false) {
      let context = this;
      if (context.loadingAssembly) {
        return false;
      }
      if (type != "refresh") {
        context.isLoading = true;
      }
      context.loadingAssembly = true;
      axios
        .get("/api/assembly/next/assistance")
        .then(response => {
          const { data, status } = response;
          if (status === 200) {
            if (data.not_found) {
              context.isLoading = false;
              context.not_found = true;
              return;
            }
            if (data.assembly.assembly_type != "virtual") {
              context.isLoading = false;
              context.not_virtual = true;
              context.family = data.family;
              //return;
            }
            context.assemblyData = data.assembly;
            context.assemblyDocuments = data.documents;
            context.total_active_families = data.total_active_families;
            context.questions = data.questions.questions;
            context.answers = data.answers;
            context.quorum = data.quorum;
            context.delegated_powers_limit =
              data.assembly.delegated_powers_limit;
            context.idAssembly = data.assembly.id;
            context.currentTime = new Date(
              data.current_time.replace(/-/g, "/")
            ); // fix safari new date()
            context.diffAssembly = data.diff_assembly;
            context.diffFinishAssembly = data.diff_finish_assembly;
            context.diffFirstCall = data.diff_first_call;
            context.diffSecondCall = data.diff_second_call;
            context.total_atendance = data.total_assistance;
            if (data.validate_agent) {
              context.alreadyAssist = data.validate_agent.agent_assistance
                ? data.validate_agent.agent_assistance > 0
                : false;
              // para re-validar asistencia (si hay cambios de poderes) :: JMG 2022-03-04
              if (
                context.alreadyAssist &&
                validate_assistance &&
                context.idAssembly
              ) {
                context.virtualAssistant(false);
              }
            }

            if (!data.documents) {
              context.assemblyError =
                "No hay documentos de firma inscritos. Informe a soporte";
              context.isLoading = false;
              return;
            }
            if (data.assembly.status == 0 || data.assembly.status == "0") {
              context.assemblyIsClosed = false;
              if (type != "refresh") {
                context.getStatus();
              }
            }
            context.loadingAssembly = false;
            context.isLoading = false;
          }
        })
        .catch(error => {
          console.log(error);
          context.isLoading = false;
        });
    },
    incrementCounter() {
      let current = new Date();
      if (this.currentTime > current) {
        current = this.currentTime;
      }
      setTimeout(() => {
        this.counter += 1;
        this.incrementCounter();
        if (this.assemblyData && this.assemblyData.assembly_finish_time) {
          this.leftTime =
            (current.getTime() -
              moment(
                this.assemblyData.assembly_date +
                  " " +
                  this.assemblyData.assembly_finish_time.substring(0, 5)
              ).valueOf()) /
            1000;
        }
      }, 100); // each second (update counters)
    },
    getStatus() {
      let context = this;
      context.isLoading = true;
      axios
        .post(`/api/documents/power_validation`, {
          id_assembly: context.idAssembly
        })
        .then(res => {
          const { data } = res;
          context.familyId = data.id;
          context.powerGranted = data.power_granted;
          context.powersReceived = data.powers_received;
          context.balance = data.balance;
          parseInt(data.balance) == 0
            ? (this.validacionCompleta = true)
            : (this.validacionCompleta = false);
          context.asopaf = data.asopaf;
          context.powerTaken = data.power_taken;
          context.assemblyMember = data.assembly_member;
          context.activeStudent = data.active_student;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(function() {
          context.isLoading = false;
        });
    },
    virtualAssistant(get_assembly = true) {
      let context = this;
      context.isLoading = true;
      if (!context.idAssembly) {
        this.getAssembly(null, true);
        return;
      }
      axios
        .post(`/api/assembly/virtual_assistance`, {
          id_assembly: context.idAssembly
        })
        .then(res => {
          const { data } = res;
          context.alreadyAssist = true;
          if (get_assembly) {
            context.getAssembly("refresh");
          } else {
            context.$store.dispatch("responseMessage", {
              type: "success",
              title: "Bienvenido",
              text:
                "Bienvenido a la " +
                context.assemblyData.description +
                " Por favor, no cierre la ventana del navegador, de lo contrario, no podrá participar de la asamblea. ",
              modal: true
            });
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(function() {
          context.isLoading = false;
        });
    },
    powerFilter(powers, filter) {
      let powersCount = [];
      if (powers && Object.keys(powers).length > 0) {
        powersCount = powers.filter(
          power => power.family_receives_power_status == filter
        );
      }
      return powersCount;
    },
    statusDocument(status) {
      switch (status) {
        case "A":
          return '<span class="blue--text text--darken-1">Aceptado</span>';
        case "F":
          return '<span class="blue--text text--darken-1">Firmado</span>';
        case "R":
          return '<span class="red--text">Rechazado</span>';
        case "P":
        default:
          return '<span class="red--text">Sin firmar</span>';
      }
    },
    formatTime(timeArray) {
      let str = "";
      str += timeArray[0] == "-" ? "en " : "hace ";
      str +=
        timeArray[1] != "0"
          ? timeArray[1] + " día" + (parseInt(timeArray[1]) > 1 ? "s " : " ")
          : "";
      str +=
        timeArray[2] != "0"
          ? timeArray[2] + " hora" + (parseInt(timeArray[2]) > 1 ? "s " : " ")
          : "";
      str +=
        timeArray[3] != "0" && timeArray[1] == "0"
          ? timeArray[3] + " minuto" + (parseInt(timeArray[3]) > 1 ? "s " : " ")
          : "";
      str +=
        timeArray[4] != "0" && timeArray[2] == "0" && timeArray[3] == "0"
          ? timeArray[4] + " segundo" + (parseInt(timeArray[4]) > 1 ? "s" : "")
          : "";
      if (str.trim() == "hace" || str.trim() == "en") str = "ahora";
      return str.trim();
    },
    showCounter(time, seconds = false) {
      let current = new Date();
      if (this.currentTime > current) {
        current = this.currentTime;
      }
      let elapsed = (current.getTime() - moment(time).valueOf()) / 1000;
      const diff = {};
      diff.days = Math.abs(parseInt(elapsed / 86400)) + "d";
      diff.hours = Math.abs(parseInt((elapsed / 3600) % 24)) + "h";
      diff.minutes = Math.abs(parseInt((elapsed / 60) % 60)) + "m";
      diff.seconds = Math.abs(parseInt(elapsed % 60)) + "s";
      let message = `${elapsed >= 0 ? "hace" : "en"} ${diff.days} ${
        diff.hours
      } ${diff.minutes} ${seconds ? diff.seconds : ""}`;
      message = message
        .replace(" 0d", "")
        .replace(" 0h", "")
        .replace(" 0m", "")
        .replace(" 0s", "")
        .trim();
      if (message == "hace" || message == "en") message = "ahora";
      return message;
    }
  },
  computed: {
    ...mapGetters({
      pageLoading: "pageLoading"
    }),
    getActualQuorum() {
      if (this.diffSecondCall[0] == "-") {
        return (
          parseInt(
            (this.total_active_families *
              this.assemblyData.min_percentage_first_call) /
              100,
            0
          ) + 1
        );
      } else {
        return parseInt(
          (this.total_active_families *
            this.assemblyData.min_percentage_second_call) /
            100,
          0
        );
      }
    },
    allValidations() {
      let errors = "";
      this.disabledLink = true;
      if (this.not_found) return "<h3>No hay asambleas activas</h3>";
      if (
        (this.diffAssembly[1] != "0" && this.diffAssembly[0] == "+") ||
        this.leftTime >= 0
      )
        return "<h3>No puede acceder a la asamblea:</h3>La asamblea ya finalizó";
      if (parseInt(this.balance) > 0)
        return (
          "<h3>No puede acceder a la asamblea y no se encuentra habilitado para votar, dado que no se encuentra a paz y salvo por todo concepto con la corporación al mes de febrero de " +
          new Date().getFullYear()
        );
      if (
        Object.keys(this.powerTaken).length > 0 &&
        this.powerTaken.document_status == "R"
      )
        return `<h3>Ha recibido ${
          this.powerFilter(this.powersReceived, "A").length
        } poder(es), pero ha(n) sido rechazado(s), verifique su correo para ver más información.</h3>Por favor diligencie la firma nuevamente para poder ingresar a la asamblea <i>(Asamblea/Gestión de Poderes)</i>`;
      if (
        Object.keys(this.powerTaken).length > 0 &&
        this.powerTaken.document_status != "F" &&
        this.powerTaken.document_status != "R"
      )
        return `<h3>Ha recibido ${
          this.powerFilter(this.powersReceived, "A").length
        } poder(es), pero no ha firmado</h3>Por favor diligencie la firma para poder ingresar a la asamblea <i>(Asamblea/Gestión de Poderes)</i>`;
      if (Object.keys(this.powerGranted).length > 0)
        return `<h3>No puede acceder a la asamblea:</h3>Ha otorgado su poder a la familia <b>${
          this.powerGranted.family_receives_power_id
        } ${
          this.powerGranted.family_name
        }<br>(estado firma: ${this.statusDocument(
          this.powerGranted.document_status
        )}, estado recepción:  ${this.statusDocument(
          this.powerGranted.family_receives_power_status
        )})`;
      if (this.diffAssembly[0] == "-")
        return `<h3>La asamblea aún no sucede. Puede oprimir 'Actualizar' luego de iniciar</h3>`;
      this.disabledLink = false;

      if (this.diffAssembly[1] != "0" && this.diffAssembly[0] == "-")
        errors += "La asamblea aún no comienza<br>";
      if (this.familyId && !this.alreadyAssist)
        errors += 'Clic a "Unirse ahora para ver link"<br>';
      if (
        this.total_atendance <
          (this.total_active_families *
            this.assemblyData.min_percentage_first_call) /
            100 +
            1 &&
        this.diffFirstCall[1] == "0" &&
        this.diffAssembly[0] == "+" &&
        this.diffSecondCall[0] != "+"
      )
        errors += `Aún no se cumple el Quórum mínimo (1a Convocatoria) -- ${this.total_atendance} ${this.getActualQuorum} <br>`;
      if (
        this.total_atendance <
          (this.total_active_families *
            this.assemblyData.min_percentage_second_call) /
            100 &&
        this.diffSecondCall[1] == "0" &&
        this.diffSecondCall[0] == "+"
      )
        errors += "Aún no se cumple el Quórum mínimo, por favor espere<br>";

      if (this.assemblyData.assembly_is_active === 0)
        return `<h3>Esperando a que el administrador active la asamblea virtual, muy pronto comenzará</h3>`;

      if (errors != "")
        errors = "<h3>No puede acceder a la asamblea:</h3>" + errors;
      return errors;
    }
  },
  watch: {}
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/assembly/access.vue